import { 
  DEVICE_TYPE,
} from '@/constants/device.js';

const deviceTypesMixin = {
  computed: {
    deviceTypes() {
      const deviceTypesArr = [];

      for(let property in DEVICE_TYPE) {
        deviceTypesArr.push({
          value: DEVICE_TYPE[property],
          text: this.$t(`device.type.${property}`)
        })
      }

      return deviceTypesArr;
    },
    deviceTypesWithAllSelector() {
      const deviceTypesArr = [];

      deviceTypesArr.push({
        text: this.$t('device.fields.allTypes'),
        value: null
      })

      for(let property in DEVICE_TYPE) {
        deviceTypesArr.push({
          value: DEVICE_TYPE[property],
          text: this.$t(`device.type.${property}`)
        })
      }

      return deviceTypesArr;
    },
  }
}

export default deviceTypesMixin;